__webpack_require__.p = "/homework-react-39/";